<template>
  <div class="message-detail-wrapper">
    <div class="detail-header">
      <p class="title">{{messageItem.title}}</p>
      <p class="date">{{messageItem.date}} {{messageItem.time}}</p>
    </div>
    <div class="detail-content">
      <p class="message" v-html="messageItem.message"></p>
    </div>
  </div>

</template>

<script>
  export default {
    data(){
      return {
        messageItem: {},
      }
    },
    created(){
      this.messageItem = this.$route.query;
    },
    methods: {
    }
  }
</script>

<style scoped lang="scss">
  .message-detail-wrapper{
    background-color: #ffffff;
    width: 100%;
    height: 100%;
    min-height: 100vh;
    .detail-header{
      @include flex;
      @include justify-content(space-between);
      padding: 14px 10px 11px;
      color: #000000;
      .title{
        font-size: 16px;
        line-height: 23px;
      }
      .date{
        font-size: 12px;
        line-height: 23px;
      }
    }
    .detail-content{
      padding: 0 10px;
      .message{
        border-top: 1PX solid #EEEEEE;
        padding: 10px 0;
        font-size: 14px;
        line-height: 22px;
        color: #666666;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/views/message/messageDetail.vue